<template>
  <div class="bg-gray-300 min-h-screen h-full px-2 py-10 overflow-y-auto">
    <!-- <h1 class="text-4xl font-bold font-sans text-red-700">Register</h1> -->
    <transition name="zoom-fade">
      <div v-if="show" >
        <Form />
      </div>
      </transition>
  </div>
</template>

<script>
import Form from '@/components/Form'
// import Navbar from '@/components/Navbar'

export default {
  name: 'Register',
  components: {
    Form
    // Navbar
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.show = !this.show
  },
  methods: {
    leavePage () {
      this.show = !this.show
      setTimeout(() => this.$router.push({ path: '/' }), 800)
    }
  }
}
</script>

<style>
/* background */
  .zoom-fade-enter-active {
    transition: all .8s ease;
  }
  .zoom-fade-enter {
    transform: translateX(-50px);
    opacity: 0;
  }
  .zoom-fade-leave-to {
    transform: translateX(50px);
    opacity: 0;
  }
</style>
